import React, { useState, Fragment, useEffect } from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import MaterialIcon from '../MaterialIcon';
import ActionButtons from '../Buttons/ActionButtons';

function ItemForm({ itemMethods, edit, isProduct }) {
	let initialData = { name: '', quantity: 1, type: 'roomtemp' };
	if (isProduct) {
		delete initialData.quantity;
	}

	let { id } = useParams();
	let { url } = useRouteMatch();
	url = url.slice(0, url.lastIndexOf('/'));

	const [ data, setData ] = useState(initialData);
	const [ errors, setErrors ] = useState({ name: '', quantity: '', duplicate: '' });
	let history = useHistory();

	useEffect(() => {
		if (edit) {
			let itemData = itemMethods.get(id);
			if (itemData) {
				itemData.oldType = itemData.type;
				itemData.initialName = itemData.name;
				setData(itemData);
			}
		}
	}, []);

	const handleNameChange = (event) => {
		setData({ ...data, name: event.target.value });
	};

	const handleQuantityChange = (event) => {
		let quantity = event.target.value;

		if (quantity >= 0 && quantity <= 999) {
			setData({ ...data, quantity: quantity });
		}
	};

	const handleCounterIncrement = () => {
		let newQuantity;
		if (data.quantity === '') {
			newQuantity = data.quantity + 1;
		} else {
			newQuantity = parseInt(data.quantity) + 1;
		}

		setData({ ...data, quantity: parseInt(newQuantity) });
	};

	const handleCounterDecrement = () => {
		let newQuantity;
		if (data.quantity === '') {
			newQuantity = 0;
		} else {
			newQuantity = parseInt(data.quantity) - 1;
		}
		if (newQuantity >= 0 && newQuantity <= 999) {
			setData({ ...data, quantity: parseInt(newQuantity) });
		}
	};

	const handleRadioChange = (event) => {
		let value = event.target.value;
		if (value === 'roomtemp' || value === 'fridge' || value === 'freezer') {
			setData({ ...data, type: value });
		} else {
			setData({ ...data, type: 'roomtemp' });
		}
	};

	const handleFormSubmit = () => {
		let formErrors = {
			name: '',
			quantity: '',
			duplicate: ''
		};

		// Check if name is valid
		if (!data.name) {
			formErrors.name = 'Veuillez entrer un nom';
		}

		// Check if quantity is valid
		if (!isProduct) {
			if (!data.quantity && data.quantity !== 0) {
				formErrors.quantity = 'Veuillez entrer une quantité';
			} else if (data.quantity <= 0) {
				formErrors.quantity = 'La quantité doit être supérieure à 0';
			} else if (isNaN(parseInt(data.quantity))) {
				formErrors.quantity = 'La quantité doit être un nombre';
			}
		}

		// Check if type is valid, otherwise give a default value
		if (data.type !== 'roomtemp' && data.type !== 'fridge' && data.type !== 'freezer') {
			data.type = 'roomtemp';
		}

		// Check if the item already exists in the specified sublist (roomtemp, etc)
		// Except in case of edit when the item's name is the same as before
		let listToCheck = isProduct ? 'products' : 'list';
		if (!edit) {
			if (itemMethods.checkDuplicates(data, listToCheck)) {
				formErrors.duplicate =
					"Ce produit existe déjà dans cette section. Vous pouvez l'ajouter à une section différente.";
			}
		}

		// Check if there are errors, if so stop function
		if (formErrors.name !== '' || formErrors.quantity !== '' || formErrors.duplicate !== '') {
			setErrors(formErrors);
			return;
		} else {
			setErrors({ name: '', quantity: '' });
		}

		if (edit) {
			itemMethods.edit(data);
		} else {
			data.checked = false;
			itemMethods.add(data);
		}
		history.push(url);
	};

	return (
		<Fragment>
			{edit && !initialData ? (
				false
			) : (
				<div className="modalBackground" onClick={(e) => history.push(url)}>
					<div className="itemFormPage" onClick={(e) => e.stopPropagation()}>
						<div className="itemForm__header">
							<h2 className="itemForm__title title">
								{edit ? `${data.initialName} - Détails` : 'Nouveau produit'}
							</h2>
						</div>

						<form
							className="itemForm container"
							onSubmit={(e) => {
								e.preventDefault();
								handleFormSubmit();
							}}
						>
							<div className="itemForm__inputDiv">
								<label htmlFor={edit ? 'newItemName' : 'editItemName'}>Nom</label>
								<input
									className="itemForm__input"
									id={edit ? 'newItemName' : 'editItemName'}
									type="text"
									placeholder="Nom"
									name="item_name"
									value={data.name}
									onChange={handleNameChange}
									autoFocus
								/>
							</div>
							{errors.name ? <p className="itemForm__error">{errors.name}</p> : ''}
							{errors.duplicate ? <p className="itemForm__error">{errors.duplicate}</p> : ''}

							{!isProduct ? (
								<div className="itemForm__inputDiv">
									<label htmlFor={edit ? 'newItemQuantity' : 'editItemQuantity'}>Quantité</label>
									<div className="itemCounter">
										<button
											type="button"
											className="itemCounter__Buttons"
											onClick={handleCounterDecrement}
										>
											<MaterialIcon>remove</MaterialIcon>
										</button>
										<input
											className="itemForm__input itemForm__counterInput"
											id={edit ? 'newItemQuantity' : 'editItemQuantity'}
											type="number"
											name="item_name"
											value={data.quantity}
											onChange={handleQuantityChange}
										/>
										<button
											type="button"
											className="itemCounter__Buttons"
											onClick={handleCounterIncrement}
										>
											<MaterialIcon>add</MaterialIcon>
										</button>
									</div>
								</div>
							) : (
								''
							)}
							{errors.quantity ? <p className="itemForm__error">{errors.quantity}</p> : ''}

							<div className="itemForm__inputDiv itemForm__inputDiv--type">
								<p className="itemForm__p">Emplacement</p>
								<div className="itemForm__typeGroup">
									<input
										checked={data.type === 'roomtemp' ? true : false}
										id={edit ? 'newItemRoomTemp' : 'editItemRoomTemp'}
										className="itemForm__radio"
										type="radio"
										value="roomtemp"
										name="item_type"
										onChange={handleRadioChange}
									/>
									<label
										htmlFor={edit ? 'newItemRoomTemp' : 'editItemRoomTemp'}
										className="itemForm__radioLabel itemForm__radioLabel--roomtemp"
									>
										En rayon
									</label>

									<input
										checked={data.type === 'fridge' ? true : false}
										id={edit ? 'newItemFridge' : 'editItemFridge'}
										className="itemForm__radio"
										type="radio"
										value="fridge"
										name="item_type"
										onChange={handleRadioChange}
									/>
									<label
										htmlFor={edit ? 'newItemFridge' : 'editItemFridge'}
										className="itemForm__radioLabel itemForm__radioLabel--fridge"
									>
										Produits frais
									</label>

									<input
										checked={data.type === 'freezer' ? true : false}
										id={edit ? 'newItemFreezer' : 'editItemFreezer'}
										className="itemForm__radio"
										type="radio"
										value="freezer"
										name="item_type"
										onChange={handleRadioChange}
									/>
									<label
										htmlFor={edit ? 'newItemFreezer' : 'editItemFreezer'}
										className="itemForm__radioLabel itemForm__radioLabel--freezer"
									>
										Congelés
									</label>
								</div>
							</div>

							<ActionButtons cancel={{ link: url }} confirm={{ type: 'submit' }} />
						</form>
					</div>
				</div>
			)}
		</Fragment>
	);
}

export default ItemForm;
